import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const findFormByPath = (forms = [], pathname) => {
  for (const form of forms) {
    if (form?.formPath === pathname) {
      return form;
    }

    if (form?.children?.length) {
      const matchedChild = findFormByPath(form.children, pathname);

      if (matchedChild) {
        return matchedChild;
      }
    }
  }

  return null;
};

const useCurrentForm = () => {
  const { pathname } = useLocation();
  const formList = useSelector((state) => state.user.formList) || [];

  return useMemo(
    () => findFormByPath(formList, pathname),
    [formList, pathname],
  );
};

export default useCurrentForm;
